import React, {useCallback, useContext, useEffect} from 'react';
import CommandsContext from '../../../../../context/commandsContext';
import useKeyPress from '../../../../../hooks/useKeyPress';
import {useMenu} from '../../../../../hooks/useMenu';
import BodyContentView from '../../../../views/bodyContentView';
import NoFlowInstallationFinished from './installation-finished';
import InstallationNoFlowPB from './installationNoFlowPB';

function NoFlowInstallationVerification({onExit}) {
  const leftPress = useKeyPress('ArrowLeft');
  const rightPress = useKeyPress('ArrowRight');
  const {onComponent, selected} = useMenu();
  const {onUpdateCommands} = useContext(CommandsContext);

  const onRight = useCallback(() => {
    onComponent(<InstallationNoFlowPB />);
  }, []);

  useEffect(() => {
    if (!leftPress) return;

    onExit();
  }, [leftPress]);

  useEffect(() => {
    if (!rightPress) return;

    onRight();
  }, [rightPress]);

  useEffect(() => {
    onUpdateCommands({onLeft: onExit, onRight});
  }, [onExit, onRight]);

  return (
    <BodyContentView
      title="Installation Verification"
      left="Abort"
      right="Continue"
      caption="The flow rate must be zero in order to verify your installation. This procedure may take approximately 5 minutes."
    />
  );
}

export default NoFlowInstallationVerification;
